<template>
  <div>
    <Head :title="form.name" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/">Моё оборудование</Link>
      <span class="text-indigo-400 font-medium">/</span>
      {{ this.inventory.sku }}
    </h1>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.sku" disabled="disabled" :error="form.errors.sku" class="pb-8 pr-6 w-full" label="Инвентарный номер" />
          <text-input v-model="form.name" disabled="disabled" :error="form.errors.name" class="pb-8 pr-6 w-full" label="Наименование" />
          <text-input v-model="form.type_name" disabled="disabled" class="pb-8 pr-6 w-full" label="Тип оборудования" />
          <text-input v-model="form.serial" disabled="disabled" class="pb-8 pr-6 w-full" label="Серийный номер" />
          <text-input v-model="form.branch_name" disabled="disabled" class="pb-8 pr-6 w-full" label="Филиал" />
          <text-input v-model="form.department_name" disabled="disabled" class="pb-8 pr-6 w-full" label="Отдел" />
          <text-input v-if="inventory.status_id === 10" v-model="form.room" :error="form.errors.room" class="pb-8 pr-6 w-full lg:w-1/2" label="Кабинет/Помещение" />
        </div>
        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button v-if="inventory.status_id === 10" :loading="form.processing" class="btn-indigo ml-auto" type="submit">Сохранить</loading-button>
        </div>
      </form>
    </div>
    <div v-if="inventory.status_id === 10">
      <h1 class="mb-8 mt-8 text-3xl font-bold">Перемещение оборудования</h1>
      <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
        <form @submit.prevent="move">
          <div class="flex flex-wrap -mb-8 -mr-6 p-8">
            <select-input v-model="moveForm.department_id" :error="moveForm.errors.department_id" class="pb-8 pr-6 w-full lg:w-1/2" label="Выберите подразделение для перемещения">
              <option :value="null" />
              <option v-for="department in departments" :key="department.id" :value="department.id">{{ department.branch.name }} / {{ department.name }}</option>
            </select-input>
          </div>
          <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
            <loading-button :loading="moveForm.processing" class="btn-indigo ml-auto" type="submit">Переместить</loading-button>
          </div>
        </form>
      </div>
    </div>
    <div v-if="inventory.status_id === 20">
      <h1 class="mb-8 mt-8 text-3xl font-bold">Приёмка оборудования</h1>
      <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
        <form @submit.prevent="accept">
          <div class="flex flex-wrap -mb-8 -mr-6 p-8">

            <div style="font-weight: bold">Оборудование перемещается в:</div>
            <div class="mb-5 mt-5">
            {{ inventory.department.branch.name }} ({{ inventory.department.branch.location }}),
            {{ inventory.department.name }}<br/>
            </div>
            <text-input v-model="form.room" :error="form.errors.room" class="pb-8 pr-6 w-full" label="Кабинет/Помещение" />
          </div>
          <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
            <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Подтвердить перемещение</loading-button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'

export default {
  components: {
    Head,
    Icon,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
  },
  layout: Layout,
  props: {
    inventory: Object,
    departments: Array
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        sku: this.inventory.sku,
        name: this.inventory.name,
        room: this.inventory.room,
        serial: this.inventory.serial ? this.inventory.serial : 'n/a',
        type_name: this.inventory.type?.name,
        department_id: this.inventory.department_id,
        department_name: this.inventory.department?.name,
        branch_name: this.inventory.department?.branch?.name
      }),
      moveForm: this.$inertia.form({
        department_id: '',
      }),
    }
  },
  methods: {
    update() {
      this.form.put(`/inventories/${this.inventory.id}`)
    },
    accept() {
      this.form.put(`/inventories/${this.inventory.id}/accept`)
    },
    move() {
      this.moveForm.post(`/inventories/${this.inventory.id}/move`)
    },
  },
}
</script>
